export default __webpack_public_path__ + "static/media/3d.862cb4d1.png";